import { c as _c } from "react/compiler-runtime";
import DateContent from './DateContent';
import LanguageContent from './LanguageContent';
import PersonsContent from './PersonsContent';
import TimeContent from './TimeContent';
const BookingDetailFiltersSummary = t0 => {
    const $ = _c(17);
    const { filters, completion } = t0;
    let t1;
    if ($[0] !== completion || $[1] !== filters) {
        t1 = "persons" in filters ? <PersonsContent persons={filters.persons} completion={completion}/> : null;
        $[0] = completion;
        $[1] = filters;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[3] !== completion || $[4] !== filters) {
        t2 = "language" in filters ? <LanguageContent language={filters.language} completion={completion}/> : null;
        $[3] = completion;
        $[4] = filters;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    let t3;
    if ($[6] !== completion || $[7] !== filters) {
        t3 = "date" in filters ? <DateContent date={filters.date} completion={completion}/> : null;
        $[6] = completion;
        $[7] = filters;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    let t4;
    if ($[9] !== completion || $[10] !== filters) {
        t4 = "time" in filters ? <TimeContent time={filters.time} completion={completion}/> : null;
        $[9] = completion;
        $[10] = filters;
        $[11] = t4;
    }
    else {
        t4 = $[11];
    }
    let t5;
    if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
        t5 = <div className="filters-summary mb-6">{t1}{t2}{t3}{t4}</div>;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    }
    else {
        t5 = $[16];
    }
    return t5;
};
export default BookingDetailFiltersSummary;
